const RUNNING_DELIVERY_429_MAX_ATTEMPTS = 3;

function runningDeliveryRetryAfterMs(response, attempt) {
  const raw = String(response?.headers?.get?.('retry-after') || '').trim();
  if (raw) {
    const seconds = Number(raw);
    if (Number.isFinite(seconds) && seconds >= 0) {
      return Math.min(seconds * 1000, 30000);
    }

    const retryAt = Date.parse(raw);
    if (Number.isFinite(retryAt)) {
      return Math.min(Math.max(0, retryAt - Date.now()), 30000);
    }
  }

  return Math.min(1000 * (2 ** Math.max(0, attempt - 1)), 5000);
}

async function runningDeliveryFetchWith429Retry(fetchImpl, url, options = {}, retryOptions = {}) {
  const maxAttempts = Math.max(1, Number(retryOptions.maxAttempts) || RUNNING_DELIVERY_429_MAX_ATTEMPTS);
  const sleep = retryOptions.sleep || ((milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds)));

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    const response = await fetchImpl(url, options);
    if (response.status !== 429 || attempt === maxAttempts) return response;
    await sleep(runningDeliveryRetryAfterMs(response, attempt));
  }
}

if (typeof globalThis !== 'undefined') {
  // eslint-disable-next-line no-undef
  globalThis.RunningDeliveryHttp429 = {
    fetchWithRetry: runningDeliveryFetchWith429Retry,
    retryAfterMs: runningDeliveryRetryAfterMs
  };
}

(() => {
  if (typeof document === 'undefined') return;
  const root = document.getElementById('ll-root');
  if (!root) return;

  const isLoggedIn = root.dataset.loggedIn === 'true';
  const rechnungOk = root.dataset.rechnungOk === 'true';
  const hasDeliveryAddress = root.dataset.hasDeliveryAddress === 'true';
  const canSaveRunningDelivery = isLoggedIn && rechnungOk && hasDeliveryAddress;
  const GET_URL = appProxyUrlCandidates(root.dataset.getUrl, '/apps/laufende-lieferung/dauerbestellung/get');
  const SAVE_URL = appProxyUrlCandidates(root.dataset.saveUrl, '/apps/laufende-lieferung/dauerbestellung/save');
  const CART_URL = window.Shopify.routes.root + 'cart.js';
  const CART_CHANGE_URL = window.Shopify.routes.root + 'cart/change.js';
  const RULES_URL = appProxyUrlCandidates(root.dataset.rulesUrl, '/apps/laufende-lieferung/dauerbestellung/rules');

  const showImages = String(root.dataset.showImages || 'true') === 'true';
  const showSku = String(root.dataset.showSku || 'true') === 'true';
  const imageRatio = String(root.dataset.imageRatio || 'adapt');
  const moneyFormat = root.dataset.moneyFormat || '{{ amount_with_comma_separator }} €';

  const $status = document.getElementById('ll-status');
  const $loading = document.getElementById('ll-loading');
  const $empty = document.getElementById('ll-empty');
  const $table = document.getElementById('ll-table');
  const $body = document.getElementById('ll-body');
  const $save = document.getElementById('ll-save');
  const $settings = document.getElementById('ll-settings');
  const $active = document.getElementById('ll-active');
  const $vacationList = document.getElementById('ll-vacation-list');
  const $addVacation = document.getElementById('ll-add-vacation');

  const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat'];//, 'sun'];
  const DAY_LABELS = { mon: 'Mo', tue: 'Di', wed: 'Mi', thu: 'Do', fri: 'Fr', sat: 'Sa'};//, sun: 'So' };
  const DAY_INDEX_TO_KEY = { 1: 'mon', 2: 'tue', 3: 'wed', 4: 'thu', 5: 'fri', 6: 'sat', 0: 'sun' };
  const DAY_NAME_TO_KEY = {
    mo: 'mon',
    mon: 'mon',
    montag: 'mon',
    di: 'tue',
    tue: 'tue',
    dienstag: 'tue',
    mi: 'wed',
    wed: 'wed',
    mittwoch: 'wed',
    do: 'thu',
    thu: 'thu',
    donnerstag: 'thu',
    fr: 'fri',
    fri: 'fri',
    freitag: 'fri',
    sa: 'sat',
    sat: 'sat',
    samstag: 'sat',
    so: 'sun',
    sun: 'sun',
    sonntag: 'sun'
  };

  const state = {
    items: [],
    active: true,
    vacationPeriods: [],
    saving: false
  };

  function normalizeAppProxyUrl(url, fallback) {
    const raw = String(url || fallback || '').trim();
    if (!raw) return fallback;

    try {
      const parsed = new URL(raw, window.location.origin);
      parsed.pathname = parsed.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(\/apps\/)/i, '$1');
      if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.toString();
    } catch {
      return raw.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(\/apps\/)/i, '$1');
    }
  }

  function appProxyUrlCandidates(url, fallback) {
    const normalized = normalizeAppProxyUrl(url, fallback);
    const fallbackUrl = normalizeAppProxyUrl(fallback, fallback);

    return [normalized, fallbackUrl].filter((candidate, index, list) =>
      candidate && list.indexOf(candidate) === index
    );
  }

  function getSaveBlockMessage() {
    if (!isLoggedIn) {
      return root.dataset.loginText || 'Bitte logge dich ein, um deine laufende Lieferung zu verwalten.';
    }

    if (!hasDeliveryAddress) {
      return root.dataset.blockedNoAddressText || 'Bitte lege zuerst eine Lieferadresse in deinem Kundenkonto an.';
    }

    if (!rechnungOk) {
      return root.dataset.blockedNoInvoiceText || 'Du kannst die laufende Lieferung nur speichern, wenn du fuer Kauf auf Rechnung freigegeben bist.';
    }

    return '';
  }

  function formatStoredPrice(value) {
    const n = Number(String(value || '').replace(',', '.'));
    if (!Number.isFinite(n)) return String(value || '');

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(Math.round(n * 100), moneyFormat);
    }

    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function setStatus(message, type = '') {
    if (!$status) return;
    $status.textContent = message || '';
    $status.className = 'll-status';
    if (type) $status.classList.add(`ll-status--${type}`);
  }

  function clearStatus() {
    setStatus('');
  }

  function defaultDays() {
    return { mon: 0, tue: 0, wed: 0, thu: 0, fri: 0, sat: 0};//, sun: 0 };
  }

  function parseJsonStringArray(value) {
    if (Array.isArray(value)) {
      return value.map((x) => String(x || '').trim()).filter(Boolean);
    }

    const raw = String(value || '').trim();
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((x) => String(x || '').trim()).filter(Boolean);
      }
    } catch (e) {}

    return raw
      .split(/[,\n;|]+/)
      .map((s) => s.replace(/^["']|["']$/g, '').trim())
      .filter(Boolean);
  }

  function normalizeBlockedWeekdays(value) {
    const arr = Array.isArray(value) ? value : parseJsonStringArray(value);
    const out = new Set();

    for (const entry of arr) {
      if (entry == null) continue;

      if (typeof entry === 'number' || /^\d+$/.test(String(entry).trim())) {
        const key = DAY_INDEX_TO_KEY[Number(entry)];
        if (key && DAY_KEYS.includes(key)) out.add(key);
        continue;
      }

      const key = DAY_NAME_TO_KEY[String(entry).trim().toLowerCase()];
      if (key && DAY_KEYS.includes(key)) out.add(key);
    }

    return Array.from(out);
  }

  function mergeBlockedWeekdays(a, b) {
    return Array.from(new Set([
      ...normalizeBlockedWeekdays(a),
      ...normalizeBlockedWeekdays(b)
    ]));
  }

  function mergeBlockedDates(a, b) {
    return Array.from(new Set([
      ...parseJsonStringArray(a),
      ...parseJsonStringArray(b)
    ]));
  }

  function isDayBlocked(item, dayKey) {
    return Array.isArray(item?.blockedWeekdays) && item.blockedWeekdays.includes(dayKey);
  }

  function normalizeDays(days) {
    const base = defaultDays();
    const src = days && typeof days === 'object' ? days : {};
    for (const key of DAY_KEYS) {
      const n = parseInt(src[key] ?? 0, 10);
      base[key] = Number.isFinite(n) && n > 0 ? n : 0;
    }
    return base;
  }

  function normalizeIsoDate(value) {
    const raw = String(value || '').trim();
    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return '';

    const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
    if (
      date.getUTCFullYear() !== Number(match[1]) ||
      date.getUTCMonth() !== Number(match[2]) - 1 ||
      date.getUTCDate() !== Number(match[3])
    ) return '';

    return raw;
  }

  function normalizeVacationPeriods(periods) {
    if (!Array.isArray(periods)) return [];
    const unique = new Map();

    for (const period of periods) {
      let startDate = normalizeIsoDate(period?.startDate);
      let endDate = normalizeIsoDate(period?.endDate);
      if (!startDate || !endDate) continue;
      if (startDate > endDate) [startDate, endDate] = [endDate, startDate];
      unique.set(`${startDate}:${endDate}`, { startDate, endDate });
    }

    return Array.from(unique.values()).sort((a, b) =>
      a.startDate.localeCompare(b.startDate) || a.endDate.localeCompare(b.endDate)
    );
  }

  function normalizeVariantGid(value) {
    if (!value) return '';
    const s = String(value).trim();
    if (!s) return '';
    if (s.startsWith('gid://shopify/ProductVariant/')) return s;
    if (/^\d+$/.test(s)) return `gid://shopify/ProductVariant/${s}`;
    return s;
  }

  function normalizeProductGid(value) {
    if (!value) return '';
    const s = String(value).trim();
    if (!s) return '';
    if (s.startsWith('gid://shopify/Product/')) return s;
    if (/^\d+$/.test(s)) return `gid://shopify/Product/${s}`;
    return s;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function isDefaultVariantTitle(value) {
    const s = String(value || '').trim().toLowerCase();
    return s === '' || s === 'default title';
  }

  function buildDisplayTitle(item) {
    const title = item.title || item.sku || 'Produkt';
    if (!isDefaultVariantTitle(item.variantTitle)) return `${title} – ${item.variantTitle}`;
    return title;
  }

  async function fetchJson(url, options = {}) {
    const urls = Array.isArray(url) ? url : [url];
    let lastError = null;

    for (const requestUrl of urls) {
      try {
        const res = await runningDeliveryFetchWith429Retry(fetch, requestUrl, {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            ...(options.headers || {})
          },
          ...options
        });

        const text = await res.text();
        let json = null;
        try {
          json = text ? JSON.parse(text) : null;
        } catch {
          json = null;
        }

        if (!res.ok) {
          throw new Error((json && json.message) ? json.message : `HTTP ${res.status}`);
        }

        return json;
      } catch (error) {
        lastError = error;
        if (urls.length > 1) {
          console.warn('Running delivery app proxy request failed', { url: requestUrl, error });
        }
      }
    }

    throw lastError || new Error('Request failed');
  }

  async function loadStoredPayload() {
    const json = await fetchJson(GET_URL, { method: 'GET' });
    if (!json || json.ok !== true) {
      throw new Error(json?.message || 'Gespeicherte Dauerbestellung konnte nicht geladen werden');
    }
    return {
      active: json.data?.active !== false,
      vacationPeriods: normalizeVacationPeriods(json.data?.vacationPeriods),
      items: Array.isArray(json.data?.items) ? json.data.items : []
    };
  }

  async function loadCart() {
    try {
      const json = await fetchJson(CART_URL, { method: 'GET' });
      return Array.isArray(json.items) ? json.items : [];
    } catch (error) {
      console.warn('Running delivery cart could not be loaded', error);
      return [];
    }
  }

  function itemFromStored(item) {
    return {
      variantId: normalizeVariantGid(item.variantId),
      productId: normalizeProductGid(item.productId),
      title: String(item.title || ''),
      variantTitle: String(item.variantTitle || ''),
      sku: String(item.sku || ''),
      image: String(item.image || ''),
      price: formatStoredPrice(item.price),
      active: item.active !== false,
      days: normalizeDays(item.days),
      blockedWeekdays: normalizeBlockedWeekdays(item.blockedWeekdays || item.blocked_weekdays || item.blockedDays || []),
      blockedDates: parseJsonStringArray(item.blockedDates || item.blocked_dates || []),
      source: { stored: true, cartLines: [] }
    };
  }

  function itemFromCart(cartItem, line) {
    return {
      variantId: normalizeVariantGid(cartItem.variant_id),
      productId: normalizeProductGid(cartItem.product_id),
      title: String(cartItem.product_title || cartItem.title || ''),
      variantTitle: String(cartItem.variant_title || ''),
      sku: String(cartItem.sku || ''),
      image: String(cartItem.featured_image?.url || cartItem.image || ''),
      price: String(
        cartItem.final_price != null
          ? (
              window.Shopify && typeof Shopify.formatMoney === 'function'
                ? Shopify.formatMoney(cartItem.final_price, moneyFormat)
                : (cartItem.final_price / 100).toFixed(2).replace('.', ',') + ' €'
            )
          : ''
      ),
      active: true,
      days: defaultDays(),
      blockedWeekdays: normalizeBlockedWeekdays(
        cartItem.properties?._blocked_weekdays ||
        cartItem.properties?.blocked_weekdays ||
        cartItem.properties?.blockedWeekdays ||
        []
      ),
      blockedDates: parseJsonStringArray(
        cartItem.properties?._blocked_dates ||
        cartItem.properties?.blocked_dates ||
        cartItem.properties?.blockedDates ||
        []
      ),
      source: { stored: false, cartLines: [line] }
    };
  }

  function mergeItems(storedItems, cartItems) {
    const map = new Map();

    for (const raw of storedItems) {
      const item = itemFromStored(raw);
      if (!item.variantId) continue;
      map.set(item.variantId, item);
    }

    cartItems.forEach((cartItem, idx) => {
      const line = idx + 1;
      const cartEntry = itemFromCart(cartItem, line);
      if (!cartEntry.variantId) return;

      if (!map.has(cartEntry.variantId)) {
        map.set(cartEntry.variantId, cartEntry);
        return;
      }

      const existing = map.get(cartEntry.variantId);
      if (!existing.title && cartEntry.title) existing.title = cartEntry.title;
      if (!existing.variantTitle && cartEntry.variantTitle) existing.variantTitle = cartEntry.variantTitle;
      if (!existing.sku && cartEntry.sku) existing.sku = cartEntry.sku;
      if (!existing.image && cartEntry.image) existing.image = cartEntry.image;
      if (!existing.productId && cartEntry.productId) existing.productId = cartEntry.productId;
      if (!existing.price && cartEntry.price) existing.price = cartEntry.price;
      existing.blockedWeekdays = mergeBlockedWeekdays(existing.blockedWeekdays, cartEntry.blockedWeekdays);
      existing.blockedDates = mergeBlockedDates(existing.blockedDates, cartEntry.blockedDates);
      existing.source.cartLines.push(line);
    });

    return Array.from(map.values());
  }

  function getRatio(item) {
    if (imageRatio === 'portrait') return 0.8;
    if (imageRatio === 'square') return 1;
    return 1;
  }

  function renderEmptyState() {
    if ($body) $body.innerHTML = '';
    if ($table) $table.hidden = true;
    if ($empty) $empty.hidden = false;
  }

  function renderTable() {
    if (!$body) return;

    if (!state.items.length) {
      renderEmptyState();
      return;
    }

    if ($empty) $empty.hidden = true;
    if ($table) $table.hidden = false;

    $body.innerHTML = state.items.map((item, index) => {
      const title = escapeHtml(buildDisplayTitle(item));
      const sku = escapeHtml(item.sku || '');
      const ratio = getRatio(item);

      const imageHtml = showImages && item.image
        ? `
          <a href="#" class="cart-items__media-container" style="--ratio:${ratio};" tabindex="-1" aria-hidden="true">
            <img class="cart-items__media-image" src="${escapeHtml(item.image)}" alt="">
          </a>
        `
        : '';

      const cartBadge = item.source?.cartLines?.length
        ? `<div class="ll-badge">aus Warenkorb übernommen</div>`
        : '';

      const dayInputs = DAY_KEYS.map((dayKey) => {
        const blocked = isDayBlocked(item, dayKey);
        const value = blocked ? '' : Number(item.days?.[dayKey] || 0);

        return `
        <label class="ll-day-field ${blocked ? 'll-day-field--blocked' : ''}">
          <span class="ll-day-label">${DAY_LABELS[dayKey]}</span>
          <span class="ll-day-input-wrap">
          <input
            class="ll-qty"
            type="number"
            min="0"
            step="1"
            inputmode="numeric"
            placeholder="${blocked ? '' : '0'}"
            data-action="day"
            data-index="${index}"
            data-day="${dayKey}"
            value="${value}"
            ${blocked ? 'disabled aria-disabled="true" title="An diesem Tag nicht verfügbar"' : ''}
          >
          
        </label>
      `;
      }).join('');

      return `
        <tr role="row" class="cart-items__table-row ll-row">
          <td class="cart-items__media" role="cell">
            ${imageHtml}
          </td>

          <td class="cart-items__details cart-primary-typography" role="cell">
            <p><span class="cart-items__title">${title}</span></p>
            ${item.price ? `<p class="ll-price-under">${escapeHtml(item.price)}</p>` : ''}
            ${showSku && sku ? `<p class="ll-sku">SKU: ${sku}</p>` : ''}
            ${cartBadge}
          </td>

          <td class="cart-items__quantity" role="cell">
            <div class="ll-controls">
              <div class="ll-days-grid">
                ${dayInputs}
              </div>
            </div>
          </td>

          <td class="cart-items__price cart-secondary-typography" role="cell">
            <div class="ll-remove-wrap">
             
              <button
                type="button"
                class="button button--tertiary cart-items__remove"
                data-action="remove"
                data-index="${index}"
                aria-label="Produkt entfernen"
              >
                <span class="svg-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" width="20" height="20" aria-hidden="true">
                    <path class="remove-icon-top" d="M6.5 4.5h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    <path class="remove-icon-bottom" d="M5.5 6.5h7l-.6 7.2a1 1 0 0 1-1 .8H7.1a1 1 0 0 1-1-.8L5.5 6.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M7.5 8.5v3.5M10.5 8.5v3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </span>
                <span class="visually-hidden">Entfernen</span>
              </button>
            </div>
          </td>
        </tr>
      `;
    }).join('');
  }

  function renderSettings() {
    if ($settings) $settings.hidden = false;
    if ($active) {
      $active.checked = state.active;
      $active.disabled = !canSaveRunningDelivery || state.saving;
    }
    if ($addVacation) $addVacation.disabled = !canSaveRunningDelivery || state.saving;
    if (!$vacationList) return;

    if (state.vacationPeriods.length === 0) {
      $vacationList.innerHTML = '<p class="ll-vacation-empty">Kein Urlaub eingetragen.</p>';
      return;
    }

    const disabledAttribute = (!canSaveRunningDelivery || state.saving) ? ' disabled' : '';
    $vacationList.innerHTML = state.vacationPeriods.map((period, index) => `
      <div class="ll-vacation-row">
        <label class="ll-vacation-field">
          <span>Von</span>
          <input type="date" value="${escapeHtml(period.startDate)}" data-action="vacation-date" data-field="startDate" data-index="${index}"${disabledAttribute}>
        </label>
        <label class="ll-vacation-field">
          <span>Bis</span>
          <input type="date" value="${escapeHtml(period.endDate)}" data-action="vacation-date" data-field="endDate" data-index="${index}"${disabledAttribute}>
        </label>
        <button type="button" class="button button--tertiary" data-action="vacation-remove" data-index="${index}"${disabledAttribute}>
          Entfernen
        </button>
      </div>
    `).join('');
  }

  function render() {
    renderSettings();
    renderTable();
  }

  function sanitizeStateBeforeSave() {
  return state.items.map((item) => {
    const days = normalizeDays(item.days);
    for (const key of DAY_KEYS) {
      if (isDayBlocked(item, key)) {
        days[key] = 0;
      }
    }
    const active = DAY_KEYS.some((key) => Number(days[key] || 0) > 0);

    return {
      variantId: normalizeVariantGid(item.variantId),
      sku: String(item.sku || ''),
      active,
      days
    };
  }).filter((item) => item.variantId !== '');
}

  async function saveItems() {
    const payload = {
      active: state.active,
      vacationPeriods: normalizeVacationPeriods(state.vacationPeriods),
      items: sanitizeStateBeforeSave()
    };
    const json = await fetchJson(SAVE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!json || json.ok !== true) {
      throw new Error(json?.message || 'Dauerbestellung konnte nicht gespeichert werden');
    }
    return json;
  }

  function getUniqueImportedCartLines() {
    const lines = [];
    for (const item of state.items) {
      const cartLines = Array.isArray(item.source?.cartLines) ? item.source.cartLines : [];
      for (const line of cartLines) {
        if (Number.isInteger(line) && line > 0 && !lines.includes(line)) lines.push(line);
      }
    }
    return lines.sort((a, b) => b - a);
  }

  async function removeImportedCartLines() {
    const lines = getUniqueImportedCartLines();
    for (const line of lines) {
      await fetchJson(CART_CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      });
    }
  }

  async function loadRulesForVariantIds(variantIds) {
    const ids = Array.from(
      new Set(
        (variantIds || [])
          .map((id) => normalizeVariantGid(id))
          .filter(Boolean)
      )
    );

    if (!ids.length) return {};

    const json = await fetchJson(RULES_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variantIds: ids })
    });

    if (!json || json.ok !== true) {
      throw new Error(json?.message || 'Sperrtage konnten nicht geladen werden');
    }

    return json.rules || {};
  }

  function applyRulesToItems(items, rules) {
    const ruleMap = new Map();

    for (const [variantIdRaw, rule] of Object.entries(rules || {})) {
      const variantId = normalizeVariantGid(variantIdRaw);
      if (!variantId) continue;

      ruleMap.set(variantId, {
        blockedWeekdays: normalizeBlockedWeekdays(rule?.blockedWeekdays || []),
        blockedDates: parseJsonStringArray(rule?.blockedDates || [])
      });
    }

    return (Array.isArray(items) ? items : []).map((item) => {
      const variantId = normalizeVariantGid(item.variantId);
      const rule = ruleMap.get(variantId);
      if (!rule) return item;

      return {
        ...item,
        blockedWeekdays: mergeBlockedWeekdays(item.blockedWeekdays || [], rule.blockedWeekdays || []),
        blockedDates: mergeBlockedDates(item.blockedDates || [], rule.blockedDates || [])
      };
    });
  }

  async function refreshAll() {
    const [storedPayload, cartItems] = await Promise.all([
      loadStoredPayload(),
      loadCart()
    ]);

    state.active = storedPayload.active;
    state.vacationPeriods = storedPayload.vacationPeriods;
    let merged = mergeItems(storedPayload.items, cartItems);
    const rules = await loadRulesForVariantIds(merged.map((item) => item.variantId));
    merged = applyRulesToItems(merged, rules);

    state.items = merged;
    render();
  }

  function removeItem(index) {
    if (!Number.isInteger(index)) return;
    if (index < 0 || index >= state.items.length) return;
    state.items.splice(index, 1);
    render();
  }

  function updateDay(index, dayKey, value) {
    if (!Number.isInteger(index)) return;
    if (!DAY_KEYS.includes(dayKey)) return;
    if (!state.items[index]) return;

    if (isDayBlocked(state.items[index], dayKey)) {
      state.items[index].days[dayKey] = 0;
      return;
    }

    let n = parseInt(value, 10);
    if (!Number.isFinite(n) || n < 0) n = 0;
    state.items[index].days[dayKey] = n;
  }

  function bindEvents() {
    if ($active) {
      $active.disabled = !canSaveRunningDelivery;
      $active.addEventListener('change', () => {
        state.active = $active.checked;
      });
    }

    if ($addVacation) {
      $addVacation.disabled = !canSaveRunningDelivery;
      $addVacation.addEventListener('click', () => {
        const today = new Date().toISOString().slice(0, 10);
        state.vacationPeriods.push({ startDate: today, endDate: today });
        renderSettings();
      });
    }

    if ($vacationList) {
      $vacationList.addEventListener('input', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.dataset.action !== 'vacation-date') return;
        const period = state.vacationPeriods[Number(input.dataset.index)];
        if (!period || !['startDate', 'endDate'].includes(input.dataset.field)) return;
        period[input.dataset.field] = input.value;
      });

      $vacationList.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const button = target.closest('[data-action="vacation-remove"]');
        if (!button) return;
        const index = Number(button.getAttribute('data-index'));
        if (!Number.isInteger(index) || index < 0 || index >= state.vacationPeriods.length) return;
        state.vacationPeriods.splice(index, 1);
        renderSettings();
      });
    }

    if ($body) {
      $body.addEventListener('input', (event) => {
        const el = event.target;
        if (!(el instanceof HTMLElement)) return;
        const action = el.dataset.action;
        const index = Number(el.dataset.index);

        if (action === 'day') {
          updateDay(index, el.dataset.day, el.value);
        }
      });

      $body.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const btn = target.closest('[data-action="remove"]');
        if (!btn) return;
        removeItem(Number(btn.getAttribute('data-index')));
      });
    }

    if ($save) {
      $save.disabled = !canSaveRunningDelivery;

      $save.addEventListener('click', async () => {
        if (state.saving) return;

        if (!canSaveRunningDelivery) {
          setStatus(getSaveBlockMessage(), 'error');
          return;
        }

        state.saving = true;
        $save.disabled = true;
        renderSettings();
        clearStatus();
        setStatus('Speichert…');

        try {
          await saveItems();

          try {
            await removeImportedCartLines();
          } catch (error) {
            console.warn('Running delivery saved, but imported cart lines could not be removed', error);
          }

          try {
            await refreshAll();
          } catch (error) {
            console.warn('Running delivery saved, but the page could not be refreshed', error);
          }

          setStatus('Dauerbestellung gespeichert.', 'success');
        } catch (error) {
          setStatus(error instanceof Error ? error.message : 'Fehler beim Speichern', 'error');
        } finally {
          state.saving = false;
          $save.disabled = !canSaveRunningDelivery;
          renderSettings();
        }
      });
    }
  }

  async function init() {
    if (!isLoggedIn) {
      if ($loading) $loading.hidden = true;
      if ($save) $save.disabled = true;
      return;
    }

    try {
      bindEvents();
      const blockMessage = getSaveBlockMessage();
      if (blockMessage) {
        setStatus(blockMessage, 'error');
      } else {
        clearStatus();
      }
      await refreshAll();
    } catch (error) {
      renderEmptyState();
      setStatus(error instanceof Error ? error.message : 'Fehler beim Laden', 'error');
    } finally {
      if ($loading) $loading.hidden = true;
    }
  }

  window.addEventListener('pageshow', async (event) => {
    const nav = performance.getEntriesByType('navigation')[0];
    const fromBackForward = event.persisted || nav?.type === 'back_forward';
    if (!fromBackForward || !isLoggedIn) return;

    try {
      setStatus('Aktualisiere…');
      await refreshAll();
      setStatus('');
    } catch (error) {
      renderEmptyState();
      setStatus(error instanceof Error ? error.message : 'Fehler beim Aktualisieren', 'error');
    }
  });

  init();
})();
